<app-base-pesquisa #modal titulo="Pesquisa de Lotações/Atribuições" subtitulo="Clique duas vezes em cima da linha do registro para realizar a seleção." 
    (registroSelecionado)="selecionado($event)">
    <ng-template appFiltroPesquisa>
        <div class='form-group' >
            <ejs-textbox [floatLabelType]="'Always'" appItemFocadoFiltroPesquisa [(value)]="nomeCpf" disabled="true" [placeholder]="'Paciente (nome/CPF)'"></ejs-textbox>
        </div>
        <div class="form-group">
            <input type="button" ejs-button iconCss="fas fa-search" value="Atualizar" (click)="atualizar()" cssClass="e-primary btn-block"/>
        </div>
    </ng-template>
    <ng-template appConteudoPesquisa>
        <ejs-grid #grid appGridPesquisa
            [dataSource]="registros"
            [enableVirtualization]='false' 
            [pageSettings]='{ pageSize: 100 }'
            height='100%' 
            
            [selectionSettings]="{enableToggle: false}"
            [allowFiltering]='false' 
            [allowSorting]='true' 
            [allowResizing]='true' 

            [showColumnChooser]='false'
            [showColumnMenu]='false'
           
            [allowExcelExport]='false'
            [allowPdfExport]='false'
            [allowPdfExport]='false'>
            <e-columns>
                <e-column field='id' [headerText]="'Id'" [visible]="false" [isPrimaryKey]="true"></e-column>
                <e-column field='empresaRazaoSocial' [headerText]="'Empresa'"></e-column>
                <e-column field='estabelecimentoNomeFantasia' [headerText]="'Estabelecimento'"></e-column>
                <e-column field='cargoNome' [headerText]="'Cargo'"></e-column>
                <e-column field='cargoParticularidade' [headerText]="'Part.'"></e-column>
                <e-column field='cargoCbo' [headerText]="'CBO'"></e-column>
                <e-column field='dataInicial' [headerText]="'Dt. Inicial'" [type]="'date'" [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column>
                <e-column field='tipoDataInicialTexto' [headerText]="'Tipo Dt. Inicial'"></e-column>   
                <e-column field='dataFinal' [headerText]="'Dt. Final'" [type]="'date'" [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column>
                <e-column field='tipoDataFinalTexto' [headerText]="'Tipo Dt. Final'"></e-column>   
            </e-columns>

            <e-aggregates>
                <e-aggregate>
                    <e-columns>
                        <e-column field="id" type="count">
                            <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                        </e-column>
                    </e-columns>
                </e-aggregate>
            </e-aggregates>

        </ejs-grid>
    </ng-template>
</app-base-pesquisa>
